import styled from "styled-components";

const MyGamovoreProfilLayout = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

export default MyGamovoreProfilLayout;
